import React, { useEffect, useState } from 'react';
import { Avatar, Flex, Modal, Image } from 'antd';

import img1 from '../img/fotos/500071451_1181062273820235_6005348938020942755_n.jpg'
import img2 from '../img/fotos/500123341_1181061360486993_3207996223500881644_n.jpg'
import img3 from '../img/fotos/500167313_1181063093820153_1567944894613363840_n.jpg'
import img4 from '../img/fotos/500231705_1181061557153640_3043042681900320191_n.jpg'
import img5 from '../img/fotos/500231880_1181061717153624_2554404147005539866_n.jpg'
import img6 from '../img/fotos/500232569_1181062593820203_3836900786641317232_n.jpg'
import img7 from '../img/fotos/500313288_1181063490486780_7213188528769149358_n.jpg'
import img8 from '../img/fotos/500383495_1181063123820150_2484651364134694527_n.jpg'
import img9 from '../img/fotos/500366764_1181063167153479_811560255932242234_n.jpg'
import img10 from '../img/fotos/500420196_1181056417154154_7353328941222211731_n.jpg'
import img11 from '../img/fotos/500445871_1181062843820178_2603929616497567917_n.jpg'
import img12 from '../img/fotos/500475974_1181063193820143_5161745382489625731_n.jpg'
import img13 from '../img/fotos/500524945_1181058353820627_3972059655840530078_n.jpg'
import img14 from '../img/fotos/500578609_1181062750486854_6965018317937497412_n.jpg'
import img15 from '../img/fotos/500631831_1181062320486897_8437308877328137947_n.jpg'
import img16 from '../img/fotos/500657288_1181063893820073_4121197431147532104_n.jpg'
import img17 from '../img/fotos/500705864_1181062227153573_503829426111144071_n.jpg'
import img18 from '../img/fotos/500706201_1181061477153648_3685205440385437607_n.jpg'
import img19 from '../img/fotos/500706374_1181063517153444_1254263586200267068_n.jpg'
import img20 from '../img/fotos/500706762_1181061533820309_2519141783228953277_n.jpg'
import img21 from '../img/fotos/500707462_1181063330486796_7069692312240446819_n.jpg'
import img22 from '../img/fotos/500707735_1181063263820136_4560019404543623618_n.jpg'
import img23 from '../img/fotos/500708067_1181062100486919_3604005243809777412_n.jpg'
import img24 from '../img/fotos/500708085_1181063937153402_1722628316993576692_n.jpg'
import img25 from '../img/fotos/500708524_1181062683820194_8289406281501671416_n.jpg'
import img26 from '../img/fotos/500708889_1181064023820060_4037091622558603216_n.jpg'
import img27 from '../img/fotos/500708927_1181061797153616_3105399031931591260_n.jpg'
import img28 from '../img/fotos/500736994_1181062953820167_8253252124338841859_n.jpg'
import img29 from '../img/fotos/500737830_1181063383820124_1876790623079601471_n.jpg'
import img30 from '../img/fotos/500737840_1181061387153657_5754102368445523286_n.jpg'
import img31 from '../img/fotos/500708927_1181061797153616_3105399031931591260_n.jpg'
import img32 from '../img/fotos/500736994_1181062953820167_8253252124338841859_n.jpg'
import img33 from '../img/fotos/500737830_1181063383820124_1876790623079601471_n.jpg'
import img34 from '../img/fotos/500737840_1181061387153657_5754102368445523286_n.jpg'
import img35 from '../img/fotos/500738878_1181059270487202_2675273642034159795_n.jpg'
import img36 from '../img/fotos/500738898_1181061323820330_3417386087888054611_n.jpg'
import img37 from '../img/fotos/500739040_1181056793820783_3822691935044685853_n.jpg'
import img38 from '../img/fotos/500739555_1181062173820245_3484489001840771562_n.jpg'
import img39 from '../img/fotos/500740865_1181062720486857_85986239480853608_n.jpg'
import img40 from '../img/fotos/500741092_1181062920486837_1335641038078316174_n.jpg'
import img41 from '../img/fotos/500741240_1181061603820302_1573439532796093496_n.jpg'
import img42 from '../img/fotos/500761944_1181063433820119_2082270908362815717_n.jpg'
import img43 from '../img/fotos/500762607_1181061830486946_709229908552413216_n.jpg'
import img44 from '../img/fotos/500764809_1181063980486731_2015853224354260087_n.jpg'
import img45 from '../img/fotos/500765837_1181056633820799_996383480140860004_n.jpg'
import img46 from '../img/fotos/diretoria.jpg'
import img47 from '../img/fotos/foto1.jpg'
import img48 from '../img/fotos/foto2.jpg'
import img49 from '../img/fotos/foto3.jpg'
import img50 from '../img/fotos/foto4.jpg'
import img51 from '../img/fotos/presidente.jpg'
import { isDesktop } from 'react-device-detect';




export const GaleriaCtr = ({ name }) => {

  const items = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25,
    img26, img27, img28, img29, , img30, img31, img32, img33, img34, img35, img36, img37, img38, img39, img40, img41, img42, img43, img44, img45, img46, img47, img48, img49,
    img50, img51
  ]

  const [open, setOpen] = useState(false)
  const [index, setIndex] = useState(0)

  return <div>
    <Flex gap={10} wrap >
      {
        items.map((item, index) => {
          return <Image width={ isDesktop ? 200 : 100} height={isDesktop ? 150 : 75} style={{ borderRadius: 5, objectFit: 'cover' }} key={'img-'.concat(index)} src={item}
            onClick={() => {
            //  setIndex(index)
            //  setOpen(true)
            }} />
        })
      }
    </Flex>


    {
      <Modal
        footer={null}
        title={null}
        width={"80%"}
        open={open}
        onCancel={() => setOpen(false)}
      >
        <Image src={items[index]} style={{maxHeight: "79%", maxWidth: "79%"}} />
      </Modal>
    }


  </div>
};


